import { useState, useEffect } from 'react';
import cn from 'classnames';

import Heading from 'components/heading/Heading';
import RichText from 'components/rich-text/RichText';

import { ITimelineItem } from 'source/NFR.types';

export interface TimelineItemProps extends ITimelineItem {
  delay: number;
  isLast?: boolean;
}

const TimelineItem: React.FC<TimelineItemProps> = ({ isPastDate, subTitle, text, title, progress, delay, isLast }) => {
  const [startAnimation, setStartAnimation] = useState(false);
  useEffect(() => {
    setTimeout(() => setStartAnimation(true), delay);
  });

  const animTime = progress ? 0.5 * (progress / 100) : 0.5;

  return (
    <div
      className={cn('timeline-item', {
        'timeline-item--is-active': isPastDate,
        'timeline-item--has-current-date': progress,
        'timeline-item--is-last': isLast
      })}
    >
      {title ? (
        <Heading level={3} className="timeline-item--title">
          {title}
        </Heading>
      ) : (
        // NOTE: Spacer element. Do not remove without revising the layout when title is missing
        <div className="timeline-item--title" />
      )}
      {isPastDate || progress ? (
        <>
          <div
            className="timeline-item--progress"
            style={
              startAnimation
                ? {
                    width: progress && progress <= 100 ? `${progress}%` : `100%`,
                    transition: `width ${animTime}s linear`,
                    borderBottom: isLast ? `none` : `2px solid #1f1f1f`
                  }
                : undefined
            }
          />
        </>
      ) : null}
      <div className="timeline-item--line ballmaker">
        {!!progress && <div className="timeline-item--line-gap" style={{ left: `calc(${progress}% + 0.5rem)` }} />}
      </div>
      {subTitle && (
        <Heading level={title ? 4 : 3} className="timeline-item--sub-title">
          {subTitle}
        </Heading>
      )}
      <RichText className="timeline-item--text" {...text} />
    </div>
  );
};

TimelineItem.displayName = 'TimelineItem';

export default TimelineItem;
